import COLORS from '@ui-component-library/styles/colors';

import type { LinkProps } from './Link.types';

import { S } from './Link.styles';

/**
 * NOTE: Always wrap in typography for correct font size, family etc
 */

export const Link = ({
  children,
  onClick,
  href,
  textColor = 'black',
  underline = false,
  target
}: LinkProps) => {
  const TEXT_COLORS = {
    black: COLORS['charcoal-500'],
    green: COLORS['green-pine-500'],
    yellow: COLORS['spring-yellow-500']
  };

  const click = onClick ? onClick : () => {};
  return (
    <S.Link
      target={target}
      $color={TEXT_COLORS[textColor]}
      $underline={underline}
      href={href}
      onClick={(e) => click(e)}
    >
      {children}
    </S.Link>
  );
};
